[
  {
    "id": "chapter:8a",
    "q": "If your vehicle has an anti-lock braking system and you need to stop quickly:",
    "answer": {
      "text": "Press on the brake pedal as hard as you can",
      "section": 8,
      "topic": "Braking Quickly",
      "page": 73
    },
    "otherChoices": ["Press on the brake pedal repeatedly", "Gradually press on the brake pedal"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:8b",
    "q": "If you are driving and a tire suddenly goes flat:",
    "answer": {
      "text": "Slow down gradually and do not brake",
      "section": 8,
      "topic": "Tire Blowout",
      "page": 75
    },
    "otherChoices": ["Rapidly pump the brake pedal several times", "Press on the brake pedal as hard as you can"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:8c",
    "q": "When you cannot see any farther than 100 feet ahead due to rain, snow, blowing dust, smoke or thick fog, then you cannot safely drive faster than:",
    "answer": {
      "text": "30 mph",
      "section": 8,
      "topic": "Vision Limitations",
      "page": 77
    },
    "otherChoices": ["20 mph", "40 mph"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "sample:4",
    "q": "If your vehicle begins to lose traction:",
    "answer": {
      "text": "Ease off the brakes to regain traction and reapply the brakes without skidding to continue steering",
      "section": 8,
      "topic": "Dealing with Skids",
      "page": 74
    },
    "otherChoices": [
      "Brake hard to stop the vehicle from skidding and to regain steering control",
      "Push down on the accelerator and steer to your intended path of travel"
    ],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:4:derived:a",
    "q": "If the rear tires of your vehicle lose traction:",
    "answer": {
      "text": "Turn the steering wheel in the direction of the intended path of travel",
      "section": 8,
      "topic": "Dealing with Skids",
      "page": 74
    },
    "otherChoices": [
      "Steer in the opposite direction of the intended path of travel",
      "Apply the brakes fully to regain steering control"
    ],
    "generated": {
      "parent": "sample:4",
      "type": "paired",
      "rationale": "Paired counterpart of sample:4 sourced from the same Dealing with Skids bulleted list on page 74. Where sample:4 covers the front-traction loss response, this variant covers the rear-traction loss response taught in the adjacent bullet: 'If rear traction is lost, turn the steering wheel in the direction of the intended path of travel.' The opposite-direction distractor inverts the answer. The full-braking distractor is drawn verbatim from the same page's ABS instruction in the front-traction case and tempts drivers who do not distinguish front-traction loss from rear-traction loss."
    },
    "batch": "review-20260502b",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "authored:s8-brake-failure",
    "q": "If your brakes stop working, you should first:",
    "answer": {
      "text": "Rapidly pump the brake pedal several times",
      "section": 8,
      "topic": "Brake Failure",
      "page": 75
    },
    "otherChoices": [
      "Pull on the parking brake handle as hard as you can",
      "Shift to neutral and look for an escape path"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s8-accelerator-failure",
    "q": "If the accelerator pedal gets stuck in the down position:",
    "answer": {
      "text": "Shift to neutral and search for an escape path",
      "section": 8,
      "topic": "Accelerator Failure",
      "page": 75
    },
    "otherChoices": [
      "Rapidly pump the brake pedal several times",
      "Grip the steering wheel firmly and keep the vehicle going straight"
    ],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s8-hit-from-front-glancing-blow",
    "q": "If your vehicle is about to be hit from the front, it is important to:",
    "answer": {
      "text": "Try to have a \"glancing blow\" rather than being struck head on",
      "section": 8,
      "topic": "Protect Yourself in Collisions",
      "page": 74
    },
    "otherChoices": [
      "Press yourself against the back of your seat and put your head against the head restraint",
      "Rely on the air bag to keep you behind the wheel"
    ],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 2,
    "updatedAt": "2026-07-30",
    "status": "verified"
  },
  {
    "id": "authored:s8-accelerate-to-avoid",
    "q": "Accelerating may be the best way to avoid a collision when:",
    "answer": {
      "text": "Another vehicle is about to hit you from the side or from behind and there is room to the front of your vehicle",
      "section": 8,
      "topic": "Avoiding Collisions, Accelerating",
      "page": 73
    },
    "otherChoices": ["Your vehicle is about to be hit from the front", "The vehicle ahead suddenly stops"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s8-drop-off-recovery",
    "q": "If your wheels leave the pavement at an uneven surface drop-off, you should:",
    "answer": {
      "text": "Slow down, then turn the steering wheel about one quarter-turn to return to the pavement when there is a gap in traffic",
      "section": 8,
      "topic": "Emergencies, Uneven Surface Drop-Offs",
      "page": 76
    },
    "otherChoices": [
      "Steer back onto the pavement as soon as your wheels leave it",
      "Brake hard to stop before returning to the pavement"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s8-power-failure",
    "q": "If the engine shuts off while you are driving:",
    "answer": {
      "text": "Keep a strong grip on the steering wheel, then brake with steady pressure on the pedal and slow down",
      "section": 8,
      "topic": "Emergencies, Power Failure",
      "page": 75
    },
    "otherChoices": ["Rapidly pump the brake pedal several times", "Brake hard, then pull off the roadway"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 3,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s8-hit-from-rear",
    "q": "If your vehicle is hit from the rear, your head and body will be thrown backwards. You should:",
    "answer": {
      "text": "Press yourself against the back of your seat and put your head against the head restraint",
      "section": 8,
      "topic": "Protect Yourself in Collisions",
      "page": 74
    },
    "otherChoices": [
      "Try to have a \"glancing blow\" rather than being struck head on",
      "Rely on your frontal air bag to protect you"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s8-steer-quicker-than-stop",
    "q": "When trying to avoid a collision, keep in mind that in most cases:",
    "answer": {
      "text": "You can steer the vehicle quicker than you can stop it",
      "section": 8,
      "topic": "Avoiding Collisions, Steering Quickly",
      "page": 73
    },
    "otherChoices": [
      "You can stop the vehicle quicker than you can steer it",
      "Accelerating is never an option for avoiding a collision"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s8-braking-without-abs",
    "q": "If you must stop quickly and you do not have an anti-lock braking system, braking too hard can put the vehicle into a skid. You should:",
    "answer": {
      "text": "Apply the brakes as hard as you can without locking them, and if they lock, ease up and reapply with control",
      "section": 8,
      "topic": "Avoiding Collisions, Braking Quickly",
      "page": 73
    },
    "otherChoices": [
      "Press on the brake pedal as hard as you can and keep pressing on it",
      "Take your foot off the brake pedal if the brakes lock, then reapply"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s8-low-beam-range",
    "q": "At night, you must be able to stop within the distance you can see ahead with your headlights. Your low beam headlights let you see clearly about:",
    "answer": {
      "text": "150 to 200 feet ahead",
      "section": 8,
      "topic": "Vision Limitations",
      "page": 77
    },
    "otherChoices": ["350 to 400 feet ahead", "A quarter of a mile ahead"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s8-rollover-vehicles",
    "q": "Rollover crashes are more common for:",
    "answer": {
      "text": "Sport utility vehicles (SUVs), vans, pickups, and small trucks, due to their higher centers of gravity",
      "section": 8,
      "topic": "Emergencies, Rollovers",
      "page": 76
    },
    "otherChoices": [
      "Passenger vehicles, due to their lower centers of gravity",
      "Vehicles carrying no additional cargo or passengers"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  }
]
